import { render, staticRenderFns } from "./passwordReset.vue?vue&type=template&id=3b9b5af6&scoped=true"
import script from "./passwordReset.vue?vue&type=script&lang=js"
export * from "./passwordReset.vue?vue&type=script&lang=js"
import style0 from "./passwordReset.vue?vue&type=style&index=0&id=3b9b5af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9b5af6",
  null
  
)

export default component.exports